import { OutsideClick } from '@/shared/lib/outside-click';
import { useStore } from 'effector-react';
import { useRef, useState } from 'react';
import { $notifications, fetchNotificationsFx, readAllNotificationsFx } from '../../store/root.store';
import styles from './index.module.sass';
import bellSvg from '@/modules/common/icons/notification.svg';

export const NotificationsModule = () => {
    const [notificationsAreaOpen, setNotificationsAreaOpen] = useState(false);
    const buttonRef = useRef(null);
    const iconRef = useRef(null);
    const notificationsData = useStore($notifications);
    const unreadNotificationsCount =
    notificationsData?.filter((item) => !item.read_at)?.length || 0;
    const formatter = new Intl.DateTimeFormat('ru-RU', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });

    return (
        <div className={styles.notifications}>
        <div
          className={styles.buttonBell}
          onClick={() => setNotificationsAreaOpen(!notificationsAreaOpen)}
          ref={buttonRef}
        >
          {unreadNotificationsCount > 0 && (
            <span className={styles.count}>{unreadNotificationsCount > 9 ? '9+' : unreadNotificationsCount}</span>
          )}
          <img
            ref={iconRef}
            src={bellSvg}
            alt="notifications"
            className={styles.notification}
          />
        </div>
        <OutsideClick
          onClickOutside={(e) => {
            if (e.target !== buttonRef.current && e.target !== iconRef.current) {
              setNotificationsAreaOpen(false);
            }
          }}
        >
          <div
            className={styles.notificationsArea}
            style={!notificationsAreaOpen ? { display: 'none' } : {}}
          >
            <ul className={styles.list}>
              {notificationsData && Array.isArray(notificationsData) && notificationsData.length > 0 ? notificationsData.map((item) => (
                <li
                  className={styles.notificationItem}
                  style={!item.read_at ? { fontWeight: 700 } : {}}
                >
                  <span>{item.type}</span>
                  <span className={styles.date}>{ formatter.format(new Date(item.created_at)).replace(',', '')}</span>
                </li>
              )) : <span className={styles.filler}>нет новых уведомлений</span>}
            </ul>
            <span
              className={styles.readAll}
              onClick={async () => {
                await readAllNotificationsFx();
                await fetchNotificationsFx();
              }}
            >
              отметить все как прочитанные
            </span>
          </div>
        </OutsideClick>
      </div>
    )
}